import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
// Self-hosted Pretendard (npm package, dynamic subset). Vite bundles the
// woff2 files referenced inside the CSS — no third-party CDN at runtime.
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
import "./styles/colors_and_type.css";
import "./styles/styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
